import UiLimitPagination from './UiLimitPagination'

export default function install(Vue) {
  Vue.component('UiLimitPagination', UiLimitPagination)
}
